export default __webpack_public_path__ + "static/media/sports20.eda74b55.jpg";